export default __webpack_public_path__ + "static/media/Untitled.0c61dcff.svg";